// See https://github.com/babel/babel/issues/9993
// [...document.querySelectorAll()] compiles with Babel to _toConsumableArray
// and this does not work on IE11
export function nodeListToArray(nodeList) {
    return Array.prototype.slice.call(nodeList, 0);
}